<script>
var LANGS = [
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'es', label: 'Español', flag: '🇪🇸' },
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
]

export default {
    name: 'LangSwitcher',
    props: {
        dark: Boolean,
    },
    data() {
        var seg = window.location.pathname.split('/')[1]
        var active = ['fr', 'es', 'de'].includes(seg) ? seg : 'en'
        return {
            langs: LANGS,
            activeLangCode: active,
        }
    },
    computed: {
        activeLang() {
            var code = this.activeLangCode
            return this.langs.find(function (l) { return l.code === code }) || this.langs[0]
        },
    },
    methods: {
        switchLang(code) {
            var path = this.$route.fullPath
            window.location.href = code === 'en' ? path : ('/' + code + path)
        },
    },
}
</script>

<template>
    <span :class="{ 'translate-link': true, 'dark': dark }">
        <b-link href="javascript:{}" @click="$refs.modal.show()"><b-icon icon="translate" /> {{ activeLang.label }}</b-link>

        <b-modal ref="modal" title="Sélectionner la langue" hide-footer centered no-fade size="sm">
            <div
                v-for="lang in langs"
                :key="lang.code"
                class="lang-option d-flex align-items-center rounded p-2"
                :class="{ 'bg-light': lang.code === activeLangCode }"
                @click="switchLang(lang.code)"
            >
                <span class="lang-flag mr-3">{{ lang.flag }}</span>
                <span class="flex-fill">{{ lang.label }}</span>
                <span v-if="lang.code === activeLangCode" class="text-success font-weight-bold">✓</span>
            </div>
        </b-modal>
    </span>
</template>

<style scoped>
.translate-link.dark a {
    
}
.lang-option {
    cursor: pointer;
}
.lang-option:hover {
    background-color: #f8f9fa;
}
.lang-flag {
    font-size: 1.5rem;
    line-height: 1;
}
</style>
